import React, { useContext } from 'react'
import { Icon, IconProps, Popup } from 'semantic-ui-react'
import styled, { ThemeContext } from 'styled-components'

type PositionType =
  | 'top left'
  | 'top right'
  | 'bottom right'
  | 'bottom left'
  | 'right center'
  | 'left center'
  | 'top center'
  | 'bottom center'

type InfoPopup = {
  content?: string | React.ReactElement
  styleIcon?: any
  position?: PositionType
  miWidth?: number
  backgroundTransparent?: boolean;
}

type InfoIconPopup = IconProps & InfoPopup

const InfoPopup: React.FC<InfoIconPopup> = (props) => {
  const {
    content,
    styleIcon,
    position,
    backgroundTransparent,
    miWidth,
    ...infoProps
  } = props
  const { firstColor } = useContext(ThemeContext)

  return <StyledInfoPopUpIcon
    color={backgroundTransparent ? 'white' : firstColor}
    content={content}
    position={position || 'bottom center'}
    $minWidth={miWidth || 320}
    trigger={<Icon style={{ ...styleIcon, color: styleIcon?.color || firstColor }} name='info circle' />}
    {...infoProps}
  />
}

export default InfoPopup

const StyledInfoPopUpIcon = styled(Popup)`
background: ${props => props.color} !important;
color: ${props => props?.backgroundTransparent ? 'black' : 'white'} !important;
border-radius: 10px !important;
max-height: 600px !important;
overflow-y: ${props => props?.backgroundTransparent ? 'auto' : 'hidden'};
${props => props.$minWidth && `max-width: ${props => props.$minWidth}px !important;`}
`